import { Injectable, Output, EventEmitter } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class PaginationService {
	@Output() paginateCompleteEvent: EventEmitter<any> = new EventEmitter();

	emit() {
		this.paginateCompleteEvent.emit();
	}
}
